export default "__VITE_ASSET__GIp8kuyi__"